export default "__VITE_ASSET__BxysXBUc__"